import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';
import { normalizeCursorDateTime } from '../features/pagination/cursorDateTime';

/**
 * Preserve Social snowflake IDs that exceed Number.MAX_SAFE_INTEGER.
 */
function parseTravelJson(raw) {
  if (typeof raw !== 'string' || !raw) return raw;
  const text = raw.replace(
    /("(?:postId|authorMemberId|memberId|linkedJourneyPublicationId|linkedLocationId|quotedSocialPostId|commentId|parentCommentId|rootCommentId|locationId|publicationId|id)"\s*:\s*)(\d{15,})/g,
    '$1"$2"',
  );
  return JSON.parse(text);
}

const snowflakeJson = { transformResponse: [parseTravelJson] };

function withSingleCursorCreatedAt(params = {}) {
  if (params.cursorCreatedAt == null && params.cursorCommentId == null) return params;
  const createdAt = normalizeCursorDateTime(params.cursorCreatedAt);
  const commentId = params.cursorCommentId == null ? '' : String(params.cursorCommentId);
  if (!createdAt || !/^[1-9]\d*$/.test(commentId)) {
    const { cursorCreatedAt, cursorCommentId, ...rest } = params;
    return rest;
  }
  return { ...params, cursorCreatedAt: createdAt, cursorCommentId: commentId };
}

export const socialPostApi = {
  listFollowing: (params, options = {}) => travelClient.get(travelEndpoints.followingTimeline, {
    params,
    signal: options.signal,
    ...snowflakeJson,
  }),
  create: (body) => travelClient.post(travelEndpoints.socialPosts, body, snowflakeJson),
  getDetail: (postId) => travelClient.get(travelEndpoints.socialPost(postId), snowflakeJson),
  edit: (postId, body) => travelClient.patch(travelEndpoints.socialPost(postId), body, snowflakeJson),
  changeVisibility: (postId, body) => travelClient.post(travelEndpoints.socialPostVisibility(postId), body, snowflakeJson),
  unpublish: (postId, body) => travelClient.post(travelEndpoints.socialPostUnpublish(postId), body, snowflakeJson),
  publish: (postId, body) => travelClient.post(travelEndpoints.socialPostPublish(postId), body, snowflakeJson),
  republish: (postId, body) => travelClient.post(travelEndpoints.socialPostPublish(postId), body, snowflakeJson),
  delete: (postId, body) => travelClient.post(travelEndpoints.socialPostDelete(postId), body, snowflakeJson),
  listComments: (postId, params) => travelClient.get(travelEndpoints.socialPostComments(postId), {
    params: withSingleCursorCreatedAt(params),
    ...snowflakeJson,
  }),
  createComment: (postId, body) => travelClient.post(travelEndpoints.socialPostComments(postId), body, snowflakeJson),
  listReplies: (postId, commentId, params) => travelClient.get(travelEndpoints.socialPostReplies(postId, commentId), {
    params: withSingleCursorCreatedAt(params),
    ...snowflakeJson,
  }),
  createReply: (postId, commentId, body) => travelClient.post(travelEndpoints.socialPostReplies(postId, commentId), body, snowflakeJson),
  editComment: (postId, commentId, body) => travelClient.patch(travelEndpoints.socialPostComment(postId, commentId), body, snowflakeJson),
  deleteComment: (postId, commentId, body) => travelClient.post(travelEndpoints.socialPostCommentDelete(postId, commentId), body, snowflakeJson),
  follow: (memberId) => travelClient.post(travelEndpoints.followMember(memberId)),
  unfollow: (memberId) => travelClient.post(travelEndpoints.unfollowMember(memberId)),
};
